export default "__VITE_ASSET__C68ieb3C__"